import React from 'react'

export default ({
  children
}) => (
  <div className='servicing-summary-list list'>
    {children}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/servicings/servicing-summary-list.js